import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiResponse } from "@/types/api";
import { User } from "@/helpers/types/User";
import {
  getCurrentUser,
  googleSignIn,
  GoogleSignInParams,
  GoogleSignInResponse,
  login,
  LoginParams,
  LoginResponse,
  logout,
  signUp,
  SignUpParams,
  SignUpResponse,
} from "@/api/user";
import { queryClient } from "@/lib/react-query";
import { toast } from "react-toastify";
import { useRouter } from "next/navigation";

// export const useGuestUser = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: createGuestUserIfNotExists,
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ["currentUser"] });

//       console.log("Current user query invalidated after creating guest user");
//     },
//   });
// };

export const useCurrentUser = () => {
  return useQuery<ApiResponse<User | null>, Error>({
    queryKey: ["currentUser"],
    queryFn: getCurrentUser,
  });
};

export const useSignUp = () => {
  return useMutation<SignUpResponse, Error, SignUpParams>({
    mutationFn: signUp,
    onSuccess: (data) => {
      console.log("User signed up successfully:", data);
      // Add any additional success handling logic here
    },
    onError: (error) => {
      console.error("Error during sign-up:", error.message);
      // Handle error display
    },
  });
};

export const useLogin = () => {
  return useMutation<LoginResponse, Error, LoginParams>({
    mutationFn: login,
    onSuccess: (data) => {
      console.log("Login successful:", data);
      // You can set the user data in a global state or context here
      queryClient.invalidateQueries({ queryKey: ["currentUser"] });

      // Reload the page to fully refresh the app
      window.location.reload();
      window.location.href = "/";
    },
    onError: (error) => {
      console.error("Login error:", error.message);
      // Handle error display in the UI
    },
  });
};

export const useGoogleSignIn = () => {
  return useMutation<GoogleSignInResponse, Error, GoogleSignInParams>({
    mutationFn: googleSignIn,
    onSuccess: (data) => {
      console.log("Google sign in successful:", data);

      queryClient.invalidateQueries({ queryKey: ["currentUser"] });

      window.location.reload();
      window.location.href = "/";
    },
    onError: (error) => {
      console.error("Google sign in error:", error.message);
    },
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: logout, // The logout function you defined
    onSuccess: (data) => {
      console.log("Logout successful:", data);
      toast.success(data.message || "Logged out successfully.");

      queryClient.invalidateQueries({ queryKey: ["currentUser"] });

      window.location.href = "/signin-signup";
    },
    onError: (error: Error) => {
      console.error("Logout error:", error.message);
      toast.error(error?.message || "Logout failed. Please try again.");
    },
  });
};
